import { State } from '../../reducers/rootReducer'
import { BuildabilityType } from '../../../entities/BuildabilityType'

const currentBuildabilityTypeSelector = (state: State): BuildabilityType => state.currentBuildabilityType

export default currentBuildabilityTypeSelector
